import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProjectOverviewViewModel } from '../../viewModels/project-overview.viewModel';

@Component({
  selector: 'app-delete-project',
  templateUrl: './delete-project.component.html',
  styleUrls: ['./delete-project.component.scss']
})
export class DeleteProjectComponent implements OnInit {
  @Input() project: ProjectOverviewViewModel;
  @Output() onConfirmDelete = new EventEmitter<string>();
  @Output() onCancelDelete = new EventEmitter<void>();

  private formLocked: boolean;

  constructor() { }

  ngOnInit() {
    this.formLocked = false;
  }

  confirmDelete(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onConfirmDelete.emit(this.project.id);
    }
  }

  cancelDelete(): void {
    this.onCancelDelete.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/project-overview/components/delete-project/delete-project.component.ts